import { Component } from '@angular/core';

@Component({
    selector: 'app-introduction',
    templateUrl: './introduction.component.html',
    styleUrls: ['./introduction.component.scss'],
    standalone: false,
})
export class IntroductionComponent {}
